import parseDialogue from "../../util/parseDialogue";

export const SpinnerP3 = parseDialogue(`
spinner:p3:100-200

#100 As always, an excellent job from the best agent S.M.A.R.T's got. Here are the credits they promised. Keep in touch.
>200 Ready to accept credit transfer.
`);
